import { NextRouter } from "next/router";

import CommonUtils from "~/utils/common-utils";

type PowerReviewsConfig = EVA.Core.GetApplicationConfiguration["App:Ecommerce:PowerReviewsConfig"][0];

export type PropsPowerReviewsCultureConfig = PowerReviewsConfig | void;

const powerReviewUtils = {
  getPwrConfiguration(configuration: any, router: NextRouter): PropsPowerReviewsCultureConfig {
    if (!configuration || !router) {
      return void 0;
    }
    const parsedConfig: PowerReviewsConfig[] | void = CommonUtils.parseJsonSafely(
      configuration?.["App:Ecommerce:PowerReviewsConfig"] as unknown as string
    );

    return parsedConfig?.find(
      (conf: PowerReviewsConfig) => conf?.culture?.toLowerCase() === router?.locale?.toLowerCase()
    );
  },
};

export default powerReviewUtils;
